import { useAppStore } from '@core/store'
import { irParaOrigem } from '@viewer/lib/originMarker'

/** Enquanto uma origem está em foco (o "Ir" do Info do modelo > Origens),
 *  o marcador de origens mostra só essa. Este aviso diz qual é, deixa
 *  voltar a ela e volta a mostrar todas. */
export default function OrigemEmFocoAviso() {
  const foco = useAppStore((s) => s.originMarkerFocus)
  const ligado = useAppStore((s) => s.originMarkerOverlay)
  const setFoco = useAppStore((s) => s.setOriginMarkerFocus)
  if (!foco || !ligado) return null
  return (
    <div className="pointer-events-auto absolute left-1/2 top-2 z-20 flex max-w-[min(36rem,calc(100%-1rem))] -translate-x-1/2 items-center gap-2 rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] px-2.5 py-1 text-[11px] text-[var(--color-text-muted)] shadow-lg">
      <span className="min-w-0 truncate">
        Só esta origem: <strong className="text-[var(--color-text)]">{foco.rotulo}</strong>
      </span>
      <button
        type="button"
        onClick={() => void irParaOrigem(foco.modelId, foco.chave, foco.rotulo)}
        className="shrink-0 rounded border border-[var(--color-border)] px-1.5 py-0.5 text-[10px] hover:text-[var(--color-text)]"
        title="Volta a centrar a câmara nesta origem."
      >
        Centrar
      </button>
      <button
        type="button"
        onClick={() => setFoco(null)}
        className="shrink-0 rounded border border-[var(--color-border)] px-1.5 py-0.5 text-[10px] hover:text-[var(--color-text)]"
        title="Volta a mostrar todas as origens que o filtro de origens deixa ver."
      >
        Mostrar todas
      </button>
    </div>
  )
}
